import { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Select } from '@radix-ui/themes';

import { currentDayTimeOptions, timeOptions } from '../../utils/helpers';

export const PostTimeInput = ({
  boardTimezone,
  sendHour,
  setSendHour,
  isCurrentDay,
}) => {
  const { timezone } = useSelector(state => state.currentBoard);

  const optionsToSelect = isCurrentDay
    ? currentDayTimeOptions(boardTimezone, timezone)
    : timeOptions(boardTimezone);
  const firstOptionValue = optionsToSelect[0]?.value;

  useEffect(() => {
    if (isCurrentDay) setSendHour(firstOptionValue);
  }, [firstOptionValue, isCurrentDay, setSendHour]);

  return (
    <LabelContainer id="sendHour">
      <Select.Root
        size="2"
        value={sendHour?.toString()}
        onValueChange={value => setSendHour(parseInt(value))}
      >
        <Select.Trigger style={{ width: '100%' }} />
        <Select.Content
          position="popper"
          style={{ maxHeight: '200px', zIndex: 1402 }}
        >
          {optionsToSelect.map(option => (
            <Select.Item key={option.value} value={option.value.toString()}>
              {option.label}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>
    </LabelContainer>
  );
};

const LabelContainer = styled.div`
  margin: 20px 0;

  &:last-of-type {
    margin: 0;
  }
`;
